import { Container } from '@mui/material';
import React from 'react'
import DesktopMenu from './component/DesktopMenu';
import MobileMenu from './component/MobileMenu';
import { useTheme } from '@emotion/react';

const LockerMenu = (props) => {
  const theme = useTheme();
    const menuList = [ // You can pass 4 perameters for menu title, link, target and customClass
        {
          title: "Home",
          link: "#"
        },
        {
          title: "About",
          link: "#about"
        },
        {
          title: "Wedding Proof",
          link: "#wedding-proof"
        },
        {
          title: "Tokenomics",
          link: "#tokenomics"
        },
        // {
        //   title: "Roadmap",
        //   link: "#roadmap"
        // },
        // {
        //   title: "Airdrop",
        //   link: "#airdrop"
        // },
    ];
  return (
    <div style={{backgroundColor: theme.bgPrimary}}>
      <Container>
          <DesktopMenu menuList={menuList} />
          <MobileMenu menuList={menuList} />
      </Container>
    </div>
  )
}

export default LockerMenu